import { useUser } from "../contexts/UserContext";
import { USER_TYPES } from "../types/userType";

const useIsOperate = () => {
  const { userType } = useUser();

  if (!userType) return false;
  if (Array.isArray(userType)) {
    return userType.includes(USER_TYPES.OPERATE);
  }
  return userType === USER_TYPES.OPERATE;
};

export default useIsOperate;
